import {combineReducers} from 'redux';
import PreviewMasterNoteReducer
  from './preview_master_note_reducer/PreviewMasterNoteReducer';

export default combineReducers({
  previewMasterNote: PreviewMasterNoteReducer,
});
